import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import * as VeeValidate from 'vee-validate';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCalendarAlt} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import './assets/main.css'
import Vue from 'vue'

const app = createApp(App).use(router).component("font-awesome-icon", FontAwesomeIcon);

library.add(faCalendarAlt);
app.use(router)
app.use(VeeValidate)
app.mount('#app')